import React, { useMemo, useState, useEffect } from "react";
import "./mainMenu.css";

export default function MainMenu() {
    // Ustaw tytuł strony bez Helmet
    useEffect(() => {
        const prev = document.title;
        document.title = "Menu główne – Nierówno Pod Sufitem";
        return () => { document.title = prev; };
    }, []);

    const menu = useMemo(() => ({
        "Zupy": [
            { name: "Pomidorowa z makaronem", desc: "(400ml)", price: "10,00" },
            { name: "Flaki cielęce", desc: "(400ml)", price: "15,00" },
            { name: "Żurek na wywarze grzybowym", desc: "(400ml)", price: "15,00" },
        ],
        "Dania główne": [
            { name: "Sałatka cezar z kurczakiem i boczkiem", desc: "(300g)", price: "32,00" },
            { name: "Carpaccio z buraka z serem feta i sosem musztardowo-miodowym", desc: "(300g)", price: "32,00" },
            { name: "Devolay z masłem czosnkowym", desc: "(150g) + ziemniaki / frytki, surówka", price: "28,00" },
            { name: "Kotlet schabowy", desc: "(150g) + ziemniaki / frytki, surówka", price: "28,00" },
            { name: "Bramborak (Kotlet schabowy w cieście ziemniaczanym ok. 200g) + surówka", desc: "", price: "28,00" },
            { name: "Placek po węgiersku", desc: "(150g mięsa)", price: "30,00" },
            { name: "Polędwiczki z dorsza", desc: "(około 200g ryby) + ziemniaki / frytki, surówka w sosie śmietanowo–cytrynowym", price: "48,00" },
            { name: "Polędwiczki z dorsza", desc: "(około 200g ryby) + ziemniaki / frytki, surówka w sosie szpinakowo–śmietanowym", price: "48,00" },
        ],
        "Dziecięce specjały": [
            { name: "Nugetsy drobiowe z frytkami i surówką", desc: "(100g mięsa)", price: "19,00" },
            { name: "Naleśniki z twarogiem", desc: "2 szt.", price: "19,00" },
            { name: "Naleśniki z cukrem pudrem", desc: "2 szt.", price: "12,00" },
        ],
        "Danie dnia": [
            { name: "Zestaw dnia (zupa + drugie danie)", desc: "", price: "20,00" },
            { name: "Drugie danie", desc: "", price: "18,00" },
            { name: "Zupa dnia", desc: "", price: "7,00" },
        ],
        "Dodatki do dań": [
            { name: "Ziemniaki z wody", desc: "(200g)", price: "10,00" },
            { name: "Frytki", desc: "(200g)", price: "10,00" },
            { name: "Surówka sezonowa", desc: "(200g)", price: "10,00" },
        ],
        "Deser": [
            { name: "Szarlotka na ciepło", desc: "", price: "20,00" },
        ],
        "Napoje ciepłe": [
            { name: "Kawa czarna z ekspresu", desc: "", price: "10,00" },
            { name: "Kawa parzona", desc: "", price: "10,00" },
            { name: "Cappucino", desc: "", price: "10,00" },
            { name: "Herbata czarna / smakowa", desc: "", price: "10,00" },
        ],
        "Napoje zimne": [
            { name: "Pepsi", desc: "", price: "6,00" },
            { name: "Sok owocowy", desc: "", price: "6,00" },
            { name: "Woda niegazowana/gazowana", desc: "", price: "6,00" },
            { name: "Piwo butelkowane 0,5l", desc: "", price: "10,00" },
        ],
    }), []);

    const sections = Object.keys(menu);
    const [active, setActive] = useState(sections[0]);

    const formatPrice = (p) => (/\bzł\b/i.test(p) ? p : `${p} zł`);

    return (
        <div className="mm-wrap page-wrap">
            <header className="mm-hero">
                <h1>NASZE MENU</h1>
                <p>Wybierz kategorię i zobacz pozycje.</p>

                <nav className="mm-chips" aria-label="Kategorie menu">
                    {sections.map((s) => (
                        <button
                            key={s}
                            type="button"
                            className={`mm-chip ${active === s ? "active" : ""}`}
                            onClick={() => setActive(s)}
                        >
                            {s}
                        </button>
                    ))}
                </nav>
            </header>

            <div className="mm-content">
                <section id={slug(active)} className="mm-section">
                    <h2 className="mm-section-title">{active}</h2>
                    <ul className="mm-list">
                        {menu[active].map((item, i) => (
                            <li key={`${item.name}-${i}`} className="mm-item">
                                <div className="mm-row">
                                    <div className="mm-name">{item.name}</div>
                                    <div className="mm-dots" aria-hidden="true" />
                                    <div className="mm-price">{formatPrice(item.price)}</div>
                                </div>
                                {item.desc ? <div className="mm-desc">{item.desc}</div> : null}
                            </li>
                        ))}
                    </ul>
                </section>
            </div>

            <div className="menu-notes" style={{ marginTop: 16 }}>
                <p>*Zestaw „Danie dnia” z dowozem i opakowaniami 22 zł</p>
                <p>*Opakowanie na wynos – 0,50 zł/szt.</p>
                <p>*Dowóz od zamówień powyżej 22 zł</p>
            </div>
        </div>
    );
}

function slug(s) {
    return s.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]/g, "");
}
